import { Nunito_Sans, Poppins } from "next/font/google";

export const nunitoSans = Nunito_Sans({
  display: "swap",
  style: ["normal", "italic"],
  subsets: ["latin"],
  variable: "--font-nunito-sans",
  fallback: ["sans-serif", "Arial", "Helvetica"],
  adjustFontFallback: false,
});

export const poppins = Poppins({
  display: "swap",
  subsets: ["latin"],
  weight: ["700"],
  variable: "--font-poppins",
  fallback: ["sans-serif", "Arial", "Helvetica"],
  adjustFontFallback: false,
});

export const fonts = {
  nunitoSans,
  poppins,
};
